// removed by extract-text-webpack-plugin
module.exports = {"container":"playerList__container___In44X","hr":"playerList__hr___2Hfb2"};


//////////////////
// WEBPACK FOOTER
// ./components/PlayerList/playerList.css
// module id = 272
// module chunks = 0